import React from "react"
import { GlobalOutlined } from "@ant-design/icons"
import { Space, Table as AntTable, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { Header } from "src/components/layout/header"
import { VisibilityProvider } from "src/components/visibility-provider"
import { usePermission } from "src/hooks"
import { FeedUrlsDrawer } from "src/pages-lib/point-categories/feed-urls-drawer"
import { getPointCategories } from "src/utils"
import styled from "styled-components"

/**
 * Типы точек сети: Буше, Тёплого хлеба, КофеВино Lab.
 *
 * От типа зависит вывеска филиала в фидах, набор рубрик и соцсетей. Сам
 * справочник заводится сидером, в дашборде правятся ссылки бренда.
 */
export default function PointCategories() {
  const { hasPermission } = usePermission()
  const [items, setItems] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [urlsCategory, setUrlsCategory] = React.useState(null)

  React.useEffect(() => {
    getItems()
  }, [])

  async function getItems() {
    setIsLoading(true)
    const data = await getPointCategories()
    setItems(data.map((item) => ({ ...item, key: item.id })))
    setIsLoading(false)
  }

  const canEdit = hasPermission("points.edit")

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: "ascend",
    },
    {
      title: "Название",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Код",
      dataIndex: "slug",
      key: "slug",
      render: (slug) => <StyledSlug>{slug}</StyledSlug>,
    },
    {
      title: "Сортировка",
      dataIndex: "sortWeight",
      key: "sortWeight",
    },
    ...(canEdit
      ? [
        {
          title: "Действие",
          key: "action",
          width: 100,
          render: (_, record) => (
            <Space size="small">
              <Tooltip placement="top" title="Ссылки для фидов" mouseLeaveDelay={0}>
                <Button size="small" type="link" onClick={() => setUrlsCategory(record)}>
                  <GlobalOutlined style={{ width: "16px" }} />
                </Button>
              </Tooltip>
            </Space>
          ),
        },
      ]
      : []),
  ]

  return (
    <>
      <Header title="Типы точек" />

      <AntTable
        columns={columns}
        dataSource={items}
        loading={isLoading}
        pagination={false}
      />

      <VisibilityProvider visible={Boolean(urlsCategory)}>
        <FeedUrlsDrawer category={urlsCategory} onClose={() => setUrlsCategory(null)} />
      </VisibilityProvider>
    </>
  )
}

const StyledSlug = styled.span`
  color: #8c8c8c;
  font-family: monospace;
`
